/**
 * Filtr a routing pro orchestrátor: Lokál = jen prostředí tohoto nodu.
 * Picker dává stable_id (UUID), orch_list vrací hostname — proto aliasy.
 */
import { peerMatchesKey, type MeshPeer } from '../../widgets/node-targets.ts';

export function envIsLocalToListedNode(
  env: {
    is_local?: boolean;
    primary_node?: string | null;
    target_node?: string | null;
  },
  listedHostname: string,
): boolean {
  if (env.is_local === false) return false;
  const primary = env.primary_node ?? env.target_node ?? null;
  if (!primary || primary === 'local') return true;
  if (listedHostname && primary === listedHostname) return true;
  return env.is_local === true && !listedHostname;
}

export function routingKeyForEnv(
  env: {
    owner_node_id?: string | null;
    primary_node?: string | null;
    target_node?: string | null;
    owner_node?: string | null;
    primary_node_label?: string | null;
  },
  peers: MeshPeer[],
): string | null {
  const keys = [
    env.owner_node_id,
    env.primary_node,
    env.target_node,
    env.owner_node,
    env.primary_node_label,
  ];
  for (const key of keys) {
    const k = (key ?? '').trim();
    if (!k || k === 'local' || k === 'unknown' || k.startsWith('node:')) continue;
    const hit = peers.find((p) =>
      peerMatchesKey(p, k) || p.host === k || p.name === k
    );
    if (hit) return (hit.stable_id || hit.name || '').trim() || null;
  }
  return null;
}
